import { Property, OccupantByPermission, UserPermissions } from '@centecomm/portal-service';

export enum PropertyTenantResolutionActions {
    LOAD_PROPERTY_TENANT_LIST = 'LOAD_PROPERTY_TENANT_LIST',
    SET_PROPERTY_TENANT_LIST = 'SET_PROPERTY_TENANT_LIST',
    FILL_PROPERTY_OCCUPANTS = 'FILL_PROPERTY_OCCUPANTS',
    LOAD_PROPERTY_OCCUPANTS = 'LOAD_PROPERTY_OCCUPANTS',
    RESET_PROPERTY_TENANT_LIST = 'RESET_PROPERTY_TENANT_LIST',
}

interface LoadPropertyTenantResolution {
    type: typeof PropertyTenantResolutionActions.LOAD_PROPERTY_TENANT_LIST;
    payload: {
        permission: UserPermissions;
    };
}

interface LoadPropertyOccupants {
    type: typeof PropertyTenantResolutionActions.LOAD_PROPERTY_OCCUPANTS;
}

interface SetPropertyTenantResolution {
    type: typeof PropertyTenantResolutionActions.SET_PROPERTY_TENANT_LIST;
    payload: {
        properties: Property[];
    };
}
interface ResetPropertyTenantResolution {
    type: typeof PropertyTenantResolutionActions.RESET_PROPERTY_TENANT_LIST;
}

interface FillPropertyOccupantsTenantResolution {
    type: typeof PropertyTenantResolutionActions.FILL_PROPERTY_OCCUPANTS;
    payload: {
        propertyId: number;
        occupants: OccupantByPermission[];
    };
}

export type PropertyTenantResolutionActionTypes =
    | LoadPropertyTenantResolution
    | SetPropertyTenantResolution
    | FillPropertyOccupantsTenantResolution
    | ResetPropertyTenantResolution
    | LoadPropertyOccupants;
